import { render } from "./PdfsClinicalPage.vue?vue&type=template&id=0f464a22&scoped=true"
import script from "./PdfsClinicalPage.vue?vue&type=script&lang=js"
export * from "./PdfsClinicalPage.vue?vue&type=script&lang=js"

import "./PdfsClinicalPage.vue?vue&type=style&index=0&id=0f464a22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f464a22"]])

export default __exports__